import { tap } from 'rxjs';
import { AGENT_API } from '../AgentAPI';
import { createAuthTransferService, Branch } from '@golden/gdk-base';
import { extendObj } from '@golden/utils';
export function createAuthService(api, trunk, isLoginSubject) {
    const authTransferService = createAuthTransferService('agent/', api);
    return extendObj(authTransferService, {
        login(agentLoginReq) {
            return api.fetch(AGENT_API.AGENT_LOGIN, {
                data: {
                    account: agentLoginReq.account,
                    password: agentLoginReq.password,
                    ...agentLoginReq.captcha_type ? { captcha_type: agentLoginReq.captcha_type } : {},
                    captcha: agentLoginReq.captcha
                }
            }).pipe(tap(() => {
                isLoginSubject.next(true);
            }));
        },
        logout() {
            trunk.next([Branch.CLEAR]);
            isLoginSubject.next(false);
            return api.fetch(AGENT_API.AGENT_LOGOUT);
        },
        validateAccount(data) {
            return api.fetch(AGENT_API.VALIDATE_AGENT_ACCOUNT, { data });
        },
        get isLoggedIn() {
            return isLoginSubject;
        }
    });
}
//# sourceMappingURL=AuthService.js.map